export const GET_RESCHEDULES = 'Get_Reschedules';